import { useStore } from 'effector-react';
import { changeAcceptedDocumentsVisible } from 'features/verify/features/accepted-documents';
import { routes } from 'features/verify/routes';
import { Header } from 'features/verify/ui/header';
import { first } from 'libs/arrays';
import { navigate } from 'libs/router';
import { toSentenceCase } from 'libs/to-sentence-case';
import { styled } from 'linaria/react';
import { errors$, uploadedPhotoMeta$ } from 'model/flows/verification.model';
import { useLocalization } from 'model/localization.model';
import { sessionConfig$ } from 'model/session.model';
import { h } from 'preact';
import { Button } from 'ui/atoms/button';
import { Footer } from 'ui/footer';
import { version } from '../../../../../package.json';

const Title = styled.div`
  margin-top: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: var(--text-primary);
  text-align: center;
`;
const Subtitle = styled.div`
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 16px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: var(--text-primary);
`;
const ImageContainer = styled.div`
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
`;
const TextButton = styled.button`
  margin-top: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  appearance: none;
  outline: none;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: var(--primary-color);
`;
const ButtonContainer = styled.div`
  margin: auto 16px 8px;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const NotSupportedError = () => {
	const t = useLocalization();
	const errors = useStore(errors$);
	const error = first(errors);
	const session = useStore(sessionConfig$);
	const meta = useStore(uploadedPhotoMeta$);

	const company = session.company;
	const doc_type = meta?.document_title?.toLowerCase();
	const country = toSentenceCase(t(`countries.${meta?.country_alpha2}`));

	const title = error === 'document_not_supported'
		? t('supported.err.title.doc')
		: t('supported.err.title.country');
	const subtitle = error === 'document_not_supported'
		? t('supported.err.subtitle.doc', { company, doc_type: t(`doc.type.${doc_type.replace(/ /g, '_')}.plural`) })
		: t('supported.err.subtitle.country', { company, country });

	return (
		<Wrapper>
			<Content>
				<Header/>
				<Title>{title}</Title>
				<ImageContainer>
					<img src={`https://cdn.hive.id/verify-js/${version}/images/doc_error.svg`} alt=""/>
				</ImageContainer>
				<Subtitle>{subtitle}</Subtitle>
				<TextButton onClick={() => changeAcceptedDocumentsVisible(true)}>
					{t('view.accepted.documents')}
				</TextButton>
				<ButtonContainer>
					<Button style={{ width: '100%' }} onClick={() => navigate(routes.document)}>
						{t('supported.err.btn.title')}
					</Button>
				</ButtonContainer>
			</Content>
			<Footer/>
		</Wrapper>
	);
};
